import React from "react";
import PropTypes from "prop-types";
import { BookStore, Dispatcher } from "../../flux";
import {} from "../../components";

const styles = {
  container: {
    position: "absolute",
    bottom: 3,
    left: 3,
    right: 3,
    borderRadius: 5,
    background: "#229",
    textAlign: "center",
    color: "#FFF",
    padding: 10
  },
  button: {
    color: "#000",
    float: "left",
    height: 32
  }
};

class OverlayDemo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._doSomething = this._doSomething.bind(this);
  }

  _doSomething() {
    alert("You clicked on the demo overlay button!");
  }

  render() {
    const book = BookStore.get(this.props.isbn);

    return (
      <div style={styles.container}>
        <button onClick={this._doSomething} style={styles.button}>
          A Button
        </button>
        <div>{book.title}</div>
        <div>{book.author}</div>
      </div>
    );
  }
}

OverlayDemo.propTypes = {
  isbn: PropTypes.string.isRequired
};

OverlayDemo.defaultProps = {};

const gadgetId = "overlay-demo";
module.exports = {
  class: OverlayDemo,
  metadata: () => {
    return {
      id: gadgetId,
      name: "OverlayDemo",
      type: "overlay"
    };
  }
};
